export default function () {
    return (
        <svg width="16px" height="16px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g id="终稿" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="web-二合一-Teaser" transform="translate(-1190.000000, -2824.000000)">
                    <g id="编组-8" transform="translate(977.000000, 2358.000000)">
                        <g id="编组-6" transform="translate(103.000000, 454.000000)">
                            <g id="编组-13" transform="translate(110.000000, 12.000000)">
                                <circle id="椭圆形" fill="#03060B" cx="8" cy="8" r="8"></circle>
                                <path
                                    d="M8.75,4 L8.749,7.249 L12,7.25 L12,8.75 L8.749,8.749 L8.75,12 L7.25,12 L7.249,8.749 L4,8.75 L4,7.25 L7.249,7.249 L7.25,4 L8.75,4 Z"
                                    id="形状结合"
                                    fill="#FFFFFF"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
